var render = function render(){var _vm=this,_c=_vm._self._c;return _c('froala',{ref:"editor",attrs:{"tag":'textarea',"config":_vm.froalaConfig},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }